import React, { useState, useEffect, KeyboardEvent } from 'react';
import Router from 'next/router';

// Middleware
import { useAuth } from '../../providers/Auth';
import withoutAuth from '@hocs/withoutAuth';

// Components
import Typography from '@components/UI-KIT/Typography';
import ChangePasswordRequest from '@/src/components/Session/ChangePasswordRequest';
import SessionForm from '@/src/components/Session/SessionForm';

// Material UI
import {
    Grid,
    MuiThemeProvider
} from '@material-ui/core';

// Services
import { logIn, recoveryPass, ChangePass } from '@services/session';

// style
import { THEME } from '@lib/layout/main';
import './Session.scss';
import EmailRequestHandler from '@/src/components/Session/EmailRequestHandler';

const SessionPage = () => {
    const { setLogin, setLogout } = useAuth();
    const [ state, setState ] = useState({
        username: '',
        password: '',
        email: '',
        newPassword: '',
        reEnterPass: '',
        recovery: false,
        emailSend: false,
        remember: false,
        successfulChange: false,
        error: {}
    });
    const [ submitted, setSubmitted ] = useState(false);
    const [ inputError, setInputError ] = useState(true);
    const [ failLogin, setFailLogin ] = useState(false);
    const [ failMail, setFailMail ] = useState(false);
    const [ PasswordError, setPasswordError ] = useState(true);
    const [ notEqual, setNotEqual ] = useState(false);
    const [ _notSecure, setNotSecure ] = useState(false);
    const [ session, setSession ] = useState(null);
    const [ code, setCode ] = useState(null);

    useEffect(() => {
        const session = Router.query.session as string;
        const code = Router.query.code as string;
        if (!session || !code) return;

        setCode(code);
        setSession(session);
    }, [ ]);

    const passHandler = (value:string) => {
        setState(prevState => ({
            ...prevState,
            password: value
        }));
    };

    const changeHandler = (value:string) => {
        setState(prevState => ({
            ...prevState,
            username: value
        }));
    };

    const NewPassHandler = (value:string) => {
        setState(prevState => ({
            ...prevState,
            newPassword: value
        }));
        validatePassword(value, reEnterPass);
    };
    const reEnterPassHandler = (value:string) => {
        setState(prevState => ({
            ...prevState,
            reEnterPass: value
        }));
        validatePassword2(value, newPassword);
    };

    const validateInput = (inputValue:string) => {
        const mailExpression = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
        if (inputValue.length === 0) return setInputError(true);
        if (inputValue && !inputValue.match(mailExpression)) return setInputError(true);
        return setInputError(false);
    };

    const validatePassword = (newPass:string, rePass:string) => {
        const passwordExxpression = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{7,}$/;
        if(newPass.length === 0) return setPasswordError(true);
        if (newPass && !newPass.match(passwordExxpression)){
            setPasswordError(true);
            setNotEqual(false);
            return setNotSecure(true);
        }
        else {
            setNotSecure(false);
        }
        if(newPass !== rePass) {
            setNotEqual(true);
            return setPasswordError(true);
        }
        setNotEqual(false);
        setNotSecure(false);
        return setPasswordError(false);
    };
    const validatePassword2 = (newPass:string, rePass:string) => {
        if(newPass.length === 0) return setPasswordError(true);
        if(newPass !== rePass) {
            setNotEqual(true);
            return setPasswordError(true);
        }
        setNotEqual(false);
        setNotSecure(false);
        return setPasswordError(false);
    };
    const emailHandler =  (value:string) => {
        setState(prevState => ({
            ...prevState,
            email: value
        }));
        setFailMail(false);
        validateInput(value);
    };

    const submitHandler = async () => {
        const { username, password } = state;
        setSubmitted(true);
        try {
            const res = await logIn(username, password);
            if (res.status === 201 || res.status === 200) {
                setLogin(res.data.access_token, {
                    expires: new Date(new Date().setHours(new Date().getHours() + 8)),
                    sameSite: 'lax'
                });
                Router.replace('/cuentas').catch;
            } else {
                setLogout();
                Router.reload();
            }
        } catch(e) {
            console.log(e);
            setFailLogin(true);
        }
        setSubmitted(false);
    };
    const goBackFunction = () => {
        setState(prevState => ({
            ...prevState,
            recovery: false
        }));
        setFailLogin(false);
    };

    const Recovery =  async () => {
        const { email } = state;
        setState(prevState => ({
            ...prevState,
            emailSend: false
        }));
        try{
            const res = await recoveryPass(email);
            if (res.status === 201 || res.status === 200) {
                setState(prevState => ({
                    ...prevState,
                    email: '',
                    emailSend: true
                }));
                setFailMail(false);
            }
        }
        catch(ex){
            console.log(ex);
            setFailMail(true);
        }
    };

    const returnToLogin = () => {
        setState(prevState => ({
            ...prevState,
            emailSend: false,
            recovery: false
        }));
    };

    const returnToSession = () => {
        setState(prevState => ({
            ...prevState,
            recovery: false
        }));
        setSession(null);
        setCode(null);
        Router.replace('/session').catch;
    };

    const changePassword =  async () => {
        const { newPassword } = state;
        try{
            const res = await ChangePass(newPassword.toString(), session, code);
            if (res.status === 201 || res.status === 200) {
                setState(prevState => ({
                    ...prevState,
                    successfulChange: true
                }));
            }
        }
        catch(ex){
            console.log(ex);
        }
    };

    const handleEnterPress = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== 'Enter') return;
        submitHandler();
    };

    const disabled = !state.username || !state.password;

    const {
        username,
        password,
        recovery,
        email,
        emailSend,
        newPassword,
        reEnterPass,
        successfulChange
    } = state;

    return (
        <MuiThemeProvider
            theme={THEME}
        >
            <Grid
                container
                justify="flex-end"
                className="AOL-Session-container"
            >
                <Grid
                    className="AOL-Session-background"
                />
                <Grid
                    className="AOL-Session-background-right"
                >
                    <Grid
                        className="AOL-Session-logo-image-position"
                    >
                        <img
                            src="Completo.svg"
                            width="130"
                            height="46"
                            alt="logo"
                        />
                    </Grid>
                    { (!session && !code) ? (
                        <>
                            { !recovery ? (
                                <SessionForm
                                    password={password}
                                    passHandler={passHandler}
                                    handleEnterPress={handleEnterPress}
                                    failLogin={failLogin}
                                    username={username}
                                    changeHandler={changeHandler}
                                    submitHandler={submitHandler}
                                    disabled={disabled}
                                    submitted={submitted}
                                    setState={setState}
                                />
                            ) : (
                                <EmailRequestHandler
                                    emailSend={emailSend}
                                    email={email}
                                    emailHandler={emailHandler}
                                    failMail={failMail}
                                    Recovery={Recovery}
                                    inputError={inputError}
                                    goBackFunction={goBackFunction}
                                    returnToLogin={returnToLogin}
                                />
                            )}
                        </>
                    ) : (
                        <ChangePasswordRequest
                            successfulChange={successfulChange}
                            newPassword={newPassword}
                            NewPassHandler={NewPassHandler}
                            reEnterPass={reEnterPass}
                            reEnterPassHandler={reEnterPassHandler}
                            notEqual={notEqual}
                            returnToSession={returnToSession}
                            changePassword={changePassword}
                            PasswordError={PasswordError}
                        />
                    )}
                    <Grid
                        className="AOL-Session-login-Zlogo"
                    >
                        <img
                            src="Zenrise.svg"
                            alt="logo"
                        />
                        <Grid
                            className="AOL-Session-login-Ztxt"
                        >
                            <Typography
                                variant="note-regular"
                            >
                                Creado por el equipo de Zenrise
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </MuiThemeProvider>
    );
};

export default withoutAuth(SessionPage);
